import { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { isNil } from 'lodash';
import { fromJS, isImmutable } from 'immutable';

// COMPONENTS
import DropdownMenu, { CLASSES } from 'components/DropdownMenu';
import { RadioButton } from 'components/RadioButtons';
import MaybeTranslation from 'components/MaybeTranslation';
import { CancelButton, PrimaryButton } from 'components/Buttons';

// STYLES
import {
  FilterFormContainer,
  FilterFormTitle,
  ButtonsContainer,
  RadioContainer,
  FilterItemGroup,
  FilterDropdownContainer,
} from './styles';

// CONSTANTS
import { FILTER_FORM } from 'constants/filters';
import { ifInTestingMode } from 'utils/tests.utils';

class DropdownConfiguration extends Component {
  state = {
    query: '',
    option: FILTER_FORM.dropdown[0],
    dropdownItems: fromJS([]),
    selected: null,
  };

  componentDidMount() {
    this.setDropdownItems();
  }

  setDropdownItems = () => {
    // @ts-expect-error TS(2339): Property 'column' does not exist on type 'Readonly... Remove this comment to see the full error message
    let values = this.props.column.get('filterValues') || this.props.column.get('values');

    if (!values) {
      return;
    }

    if (!isImmutable(values)) {
      values = fromJS(values);
    }

    const dropdownItems = values
      .entrySeq()
      .map((entry) => {
        const [key, value] = entry;
        if (key === 'undefined') {
          return null;
        }

        const item = fromJS({
          id: String(key),
          renderedValue: isImmutable(value) ? value.toJS() : value,
          value: key,
        });

        // @ts-expect-error TS(2339): Property 'set' does not exist on type 'Collection<... Remove this comment to see the full error message
        return item.set('handleClick', this.handleChangeSelection(item));
      })
      .toList()
      .filter((item) => item !== null);

    this.setState({
      dropdownItems,
      selected: dropdownItems.get(0),
    });
  };

  getFormItems = () => {
    if (this.state.dropdownItems.size === 0) {
      return [];
    }

    return FILTER_FORM.dropdown.map((item) => (
      <FilterItemGroup key={`number-filter-${item.translation}`}>
        <RadioContainer>
          <RadioButton
            // @ts-expect-error TS(2769): No overload matches this call.
            selected={item.translation === this.state.option.translation}
            renderedValue={{
              translationId: `components.Filters.${item.translation}`,
            }}
          />
        </RadioContainer>

        <FilterDropdownContainer data-testid={ifInTestingMode(`filter__${item.translation}`)}>
          <DropdownMenu
            className={`${CLASSES.FULL_WIDTH}`}
            items={this.state.dropdownItems}
            button
            subtle
            showSelected
          />
        </FilterDropdownContainer>
      </FilterItemGroup>
    ));
  };

  handleChangeSelection = (item) => () => {
    this.setState({ selected: item });
  };

  handleSaveFilter = () => {
    const { selected } = this.state;

    if (!isNil(selected)) {
      // @ts-expect-error TS(2339): Property 'onSave' does not exist on type 'Readonly... Remove this comment to see the full error message
      this.props.onSave(
        fromJS({
          comparator: this.state.option.comparator,
          // @ts-expect-error TS(2339): Property 'column' does not exist on type 'Readonly... Remove this comment to see the full error message
          field: this.props.column.get('name'),
          value: selected.get('value'),
        })
      );
    }
  };

  render() {
    return (
      <FilterFormContainer>
        <FilterFormTitle>
          {/* @ts-expect-error TS(2339): Property 'column' does not exist on type 'Readonly... Remove this comment to see the full error message */}
          <MaybeTranslation renderedValue={this.props.column.get('title')} />
        </FilterFormTitle>

        {this.getFormItems()}

        <ButtonsContainer>
          {/* @ts-expect-error TS(2339): Property 'onCancel' does not exist on type 'Readon... Remove this comment to see the full error message */}
          <CancelButton onClick={this.props.onCancel} />
          <PrimaryButton data-testid={ifInTestingMode('filters__apply')} onClick={this.handleSaveFilter}>
            <FormattedMessage id="components.Filters.apply" />
          </PrimaryButton>
        </ButtonsContainer>
      </FilterFormContainer>
    );
  }
}

export default DropdownConfiguration;
